<div class="content" *ngIf="!isEmpty()">
  <div class="level">
    <div class="item">
      <ng-container *ngFor="let pallet of content.pallets; let i = index">
        <div class="sku" *ngIf="pallet.skuQty === 0 && pallet.products.length === 0"
          [ngClass]="getTooltipBackgroundClass(content.groundGroup)">
          1 pallet
        </div>
        <div *ngIf="pallet.skuQty > 0 && i < 2">
          <ng-container *ngIf="pallet.skuQty === 1">
            <div *ngFor="let product of pallet.products">
              <div *ngIf="product.sku" class="sku" [ngClass]="getTooltipBackgroundClass(content.groundGroup)">
                {{product.sku}} - quantidade: {{product.quantity}}
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="pallet.skuQty > 1">
            <div class="sku" [ngClass]="getTooltipBackgroundClass(content.groundGroup)">
              pallet multireferência <span class="sku-qty">({{pallet.skuQty}} skus)</span>
            </div>
          </ng-container>
        </div>
      </ng-container>
      
      <div *ngIf="content.palletQty > 2" class="sku" [ngClass]="getTooltipBackgroundClass(content.groundGroup)">
        +{{content.palletQty - 2}} pallets
      </div>
    </div>
  </div>
</div>

<div class="empty" *ngIf="isEmpty()">
  <div class="level">
    <div class="item">
      <div class="level-name">Não existem pallets aqui.</div>
    </div>
  </div>
</div> 